/**
 * Veille de session : surveille l'expiration du JWT côté client.
 *
 * - Contrôle initial peu après le démarrage (laisse le temps à redux-persist
 *   de réhydrater l'état utilisateur) ;
 * - Contrôles réguliers toutes les minutes (+ au retour sur l'onglet / focus) ;
 * - Dès que le token est expiré, déclenche triggerSessionExpired()
 *   (purge + redirection /login), y compris sans qu'aucune requête n'ait été émise.
 */

import { getAuthToken, isTokenExpired, triggerSessionExpired } from "./sessionExpiry";

let started = false;

const check = () => {
  try {
    const token = getAuthToken();
    if (token && isTokenExpired(token)) triggerSessionExpired();
  } catch (e) {
    /* ignore */
  }
};

export const initSessionWatch = () => {
  if (started || typeof window === "undefined") return;
  started = true;

  // Après le boot (laisse redux-persist réhydrater le user persisté).
  setTimeout(check, 3000);
  // Filet de sécurité régulier.
  window.setInterval(check, 60 * 1000);
  // Au retour sur l'onglet / à la reprise du focus.
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) check();
  });
  window.addEventListener("focus", check);
};